import BaseApi from '@/api/BaseApi';
import axios from '@/plugins/api-axios';
import type { ILoginRequest, ILoginResponse } from '@/models/AuthModel';
import type { IRegisterRequest } from '@/models/RegisterModel';

export default class AuthApi extends BaseApi {
	private async prepareCsrf () {
		await axios().get('/sanctum/csrf-cookie');
	}

	async login (params: ILoginRequest) {
		// await this.prepareCsrf();
		return this.post<ILoginRequest, ILoginResponse>({
			url: '/api/login',
			data: params,
		});
	};

	async register (params: IRegisterRequest) {
		// await this.prepareCsrf();
		return this.post<IRegisterRequest, string>({
			url: '/api/set-password',
			data: params,
		});
	};
};
